import { render, staticRenderFns } from "./index.vue?vue&type=template&id=05621c44&scoped=true"
import script from "./component.js?vue&type=script&lang=js&external"
export * from "./component.js?vue&type=script&lang=js&external"
import style0 from "./index.vue?vue&type=style&index=0&id=05621c44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05621c44",
  null
  
)

export default component.exports